interface Props {
  className?: string;
  text: string;
  color?: string;
  size?: "small" | "medium" | "large";
  weight?: "light" | "medium" | "bold";
  width?: number | string;
}

const fontSizeClassName = {
  small: "text-sm",
  medium: "text-md",
  large: "text-large",
};

const fontWeightClassName = {
  light: "font-light",
  medium: "font-medium",
  bold: "font-bold",
};

export default function Text(props: Props) {
  const {
    className,
    text,
    color,
    size = "small",
    weight = "light",
    width,
  } = props;

  return (
    <div
      className={`whitespace-nowrap text-gray-700 ${fontSizeClassName[size]} ${fontWeightClassName[weight]} ${className}`}
      style={{ width, color }}
    >
      {text}
    </div>
  );
}
